import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { SOURCE_CRG } from '@rsos/components/capstone/common/Map/SpatialLayers/spatialLayersSources';
import { selectGISLayers } from '@rsos/reduxDataStore';
import { useAppSelector } from '@rsos/utils/reduxHooks';
import {
  forceStaticLayerOff,
  setActiveCRGObject,
} from '../../actions/spatialLayers';
import { useAppDispatch, type RootState } from '../../app';
import { shouldHideOldCRG } from './crgLayerVisibility';

type StaticSpatialLayer = {
  source?: string;
  isChecked?: boolean;
};

/**
 * When on ESRI Maps with a WFS CRG GIS layer, force the legacy Prague CRG
 * spatial layer off. Covers Google → ESRI switches where CRG was left on.
 */
export const useForceOffOldCRGWhenWFSPresent = (): void => {
  const dispatch = useAppDispatch();
  const mapProvider = useAppSelector(
    (state: RootState) => state.sinatra?.ui?.mapProvider,
  );
  const gisLayers = useSelector(selectGISLayers);
  const staticLayers = useAppSelector(
    (state: RootState) =>
      state.spatialLayers.staticLayers as StaticSpatialLayer[],
  );

  const hideOldCRG = shouldHideOldCRG(mapProvider, gisLayers);

  useEffect(() => {
    if (!hideOldCRG) {
      return;
    }

    const hasCheckedOldCRG = staticLayers.some(
      (layer: StaticSpatialLayer) =>
        layer.source === SOURCE_CRG && layer.isChecked,
    );

    if (!hasCheckedOldCRG) {
      return;
    }

    dispatch(forceStaticLayerOff(SOURCE_CRG));
    dispatch(setActiveCRGObject(null));
  }, [hideOldCRG, staticLayers, dispatch]);
};
